import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-compass-3-line text-base text-background-50"></i>
              </div>
              <span className="text-base font-heading font-semibold text-foreground-950 whitespace-nowrap">
                最新网址导航
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              汇聚最新网址资源，实时收录各大平台官方最新网址，帮助用户快速找到可用、安全、有效的最新网址入口。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">
              <a href="/category/search-engine" className="hover:text-primary-600 transition-colors">快速导航</a>
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/search-engine" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  网址分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">
              <span>热门分类</span>
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">
              <span>联系我们</span>
            </h4>
            <p className="text-sm text-foreground-600 mb-2">
              <i className="ri-mail-line mr-2"></i>contact@latest-url-nav.com
            </p>
            <p className="text-sm text-foreground-600">
              <i className="ri-customer-service-2-line mr-2"></i>意见反馈：关于我们页面
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 最新网址导航 - 实时更新官方网址入口
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              关于我们
            </Link>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              隐私政策
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}